import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import React from "react";
var VsComponent = function () {
    var device = DeviceContext();
    return (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null,
        React.createElement("main", { className: "vsComponent-section" },
            React.createElement("div", { className: "vsComponent-Line" }),
            React.createElement("div", { className: "vsComponent-Icon" }, "vs"),
            React.createElement("div", { className: "vsComponent-Line" })))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "vertical-circle-line" }),
        React.createElement("div", { className: "vertical-circle" }, "vs"),
        React.createElement("div", { className: "vertical-circle-line" })))));
};
export default VsComponent;
